import { useEffect } from 'react';

export interface ConfirmationModalProps {
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
    confirmText?: string;
    cancelText?: string;
    isDestructive?: boolean;
}

/**
 * Reusable confirmation modal component
 */
export const ConfirmationModal = ({
    message,
    onConfirm,
    onCancel,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    isDestructive = false
}: ConfirmationModalProps) => {
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                onCancel();
            } else if (e.key === 'Enter' && e.ctrlKey) {
                onConfirm();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [onConfirm, onCancel]);

    return (
        <div 
            className="modal-overlay" 
            onClick={onCancel}
        >
            <div 
                className="modal-dialog" 
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby="confirmation-title"
            >
                <button 
                    className="modal-close" 
                    onClick={onCancel} 
                    aria-label="Close"
                >
                    ×
                </button>

                <h2 id="confirmation-title">Confirm Action</h2>
                <p style={{ 
                    margin: '0 0 1.5rem 0', 
                    color: 'var(--color-text-secondary)',
                    lineHeight: '1.5'
                }}>
                    {message}
                </p>

                <div className="modal-actions">
                    <button 
                        onClick={onCancel} 
                        className="btn btn-secondary"
                    >
                        {cancelText}
                    </button>
                    <button 
                        onClick={onConfirm} 
                        className={`btn ${isDestructive ? 'btn-danger' : 'btn-primary'}`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

